import { useEffect, useState } from "react";

export interface GoogleCharts {
	charts: {
		load: (version: string, options: { packages: string[] }) => void;
		setOnLoadCallback: (callback: () => void) => void;
	};
	visualization: wts_approved_any;
}

declare global {
  interface Window {
//    google?: GoogleCharts;
    google?: wts_approved_any;
  }
}

//declare const window: WindowWithGoogle;

/*
function useGoogleCharts () {
	const [charts, setGoogle] = useState(null);
    
    useEffect(() => {
		if (!charts) {
			if (window.google) {
				window.google.charts.load('current', {packages: ['corechart']});
				window.google.charts.setOnLoadCallback(drawChart);

				function drawChart() {
					setGoogle(window.google);
				}				
			}

		}
   }, [charts]);

  return charts;
}
*/
function useGoogleCharts(): GoogleCharts | undefined {
	const [google, setGoogle] = useState<GoogleCharts | undefined>(undefined);
	  
	  useEffect(() => {
		  if (!google) {
			  const head: HTMLHeadElement = document.head;
  
			  let script: HTMLScriptElement | null = document.getElementById('googleChartsScript') as HTMLScriptElement;
			  if (!script) {
			  
				  script = document.createElement('script');
									  
				  script.src = 'https://www.gstatic.com/charts/loader.js';
				  script.async = true;
				  script.id = 'googleChartsScript';
				  script.onload = () => {
									  
					  if (window.google && window.google.charts) {

						window.google.charts.load('current', {packages: ['corechart']});
						window.google.charts.setOnLoadCallback(drawChart);
		
						function drawChart(): void {
							setGoogle(window.google || undefined);
						}	
					  }
				  };
				  // --
				  head.appendChild(script);
			  } else if (window.google && window.google.charts && window.google.visualization) {
				  setGoogle(window.google);
			  }
		  }
		  
		  return (): void => {
			  const script: HTMLScriptElement | null = document.getElementById('googleChartsScript') as HTMLScriptElement;
			  if (script) {
				script.remove();
			  }
		  }
	 }, [google]);
  
	return google;
  }

export default useGoogleCharts;